/**
 * Password recovery routes live under `(auth)`, but unlike login and register a
 * signed-in visitor must still be able to open them: a reset link mailed to
 * someone who is already signed in on the web is otherwise swallowed by the
 * root anchor's redirect (apps/mobile/src/app/index.tsx) and the token is lost.
 */
const PASSWORD_RECOVERY_PATHS = ['/forgot-password', '/reset-password'];

/** Accepts both `/reset-password` and the group-prefixed `/(auth)/reset-password`. */
export function isPasswordRecoveryPath(pathname: string | null | undefined) {
  if (!pathname) return false;

  const normalized =
    decodeURIComponent(pathname)
      .replace('/(auth)', '')
      .replace(/\/+$/, '') || '/';

  return PASSWORD_RECOVERY_PATHS.includes(normalized);
}
